var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 8")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation-(for-Surge)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-(no-orgs)",
    transform: "translate(-15.000000, -597.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 501.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-out"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(15.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75,22.25 L13,22.25 L13,23.75 L0.25,23.75 L0.25,0.25 L13,0.25 L13,1.75 L1.75,1.75 L1.75,22.25 Z M17.1394539,18.3413672 L16.2605476,17.4623817 L20.8503914,12.9014236 L8.70000076,12.9014236 L8.70000076,11.6513108 L20.8503914,11.6513108 L16.2605476,7.09035265 L17.1394539,6.21136713 L23.2527351,12.2763672 L17.1394539,18.3413672 Z",
    id: "Combined-Shape",
    fill: "#000000"
  })))))))));
};
export default SvgLogout;